module.exports = __webpack_public_path__ + "img/back.c2119da4.png";